import { z } from 'zod'

export const createEnrollmentSchema = z.object({
  product_id: z.string(),
  period_id: z.string(),
  workload_id: z.string(),
  workload_value: z.number().optional().nullable(),
  product_external_id: z.number().optional().nullable(),
  session_id: z.string().optional().nullable(),
})

export type CreateEnrolmentType = z.infer<typeof createEnrollmentSchema>
